import { type PropsWithChildren } from "react"
import { Typography } from "@octopus-energy/coral/atoms"

export function PageTitle({ children }: PropsWithChildren) {
    return <Typography textStyle="h3">{children}</Typography>
}
